import { render } from "./DocumentPreview.vue?vue&type=template&id=310bd6d8&scoped=true"
import script from "./DocumentPreview.vue?vue&type=script&lang=js"
export * from "./DocumentPreview.vue?vue&type=script&lang=js"

import "./DocumentPreview.vue?vue&type=style&index=0&id=310bd6d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-310bd6d8"]])

export default __exports__